import config from './index';

const amplifyConfig = {
  aws_project_region: config.region,
  aws_cognito_region: config.cognito.region,
  aws_user_pools_id: config.cognito.userPoolId,
  aws_user_pools_web_client_id: config.cognito.userPoolWebClientId,
  aws_cognito_identity_pool_id: config.cognito.identityPoolId,
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.region,
    userPoolId: config.cognito.userPoolId,
    userPoolWebClientId: config.cognito.userPoolWebClientId,
    identityPoolId: config.cognito.identityPoolId,
  },
  API: {
    endpoints: [
      {
        name: config.api.name,
        endpoint: config.api.endpoint,
        region: config.api.region,
      },
    ],
  },
};

export default amplifyConfig;